import React from 'react';
import inflection from 'inflection';

import RankIndex, {
  RankCards,
  TitleCard,
  rankRenderer,
  generateDefaultSubtitle
} from 'buyside/components/presentation/RankingsIndexPage/rankIndex/RankIndex';

const customRankRenderer = (rank, idx) => rankRenderer(rank, idx, true);

const CurrentUserRankCard = ({ currentRank, rankingCreatedDate, category }) => {
  if (currentRank) {
    const titleCategory = category === 'general' ? 'All-Time' : inflection.titleize(category);
    const defaultSubtitle = generateDefaultSubtitle(rankingCreatedDate);

    const title = 'Your Ranking - ';
    const subtitle = `${titleCategory}, ${defaultSubtitle}`;

    return (
      <RankIndex
        canViewIdeaFilterDetails
        canViewUserDetails
        showIdeasLink
        category={category}
        ranks={[currentRank]}
        hasNextPage={false}
        rankingCreatedDate={rankingCreatedDate}
      >
        <TitleCard title={title} subtitle={subtitle} />
        <RankCards isPaginated={false} customRankRenderer={customRankRenderer} />
      </RankIndex>
    );
  } else {
    return null;
  }
};

export default CurrentUserRankCard;
